<div class="modal fade" id="{{idModal}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="modalCore" aria-hidden="true">
  <div class="modal-dialog {{size}} {{classPosition}}">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col-12 text-right">
            <button type="button" class="btn-close-modal govco-svg govco-times" data-bs-dismiss="modal" aria-label="Cerrar"></button>
          </div>
        </div>

        <div [innerHTML]="safeHTML"></div>

        <div class="row mb-3">
          <div class="col-12 text-center my-2 d-flex justify-content-center">
            <button type="button" class="btn-govco fill-btn-govco" data-bs-dismiss="modal" style="width: 165px; height: 42px;">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>